// Pathify
import {make} from 'vuex-pathify'
import api from "@/services/api";
import {toast} from '@/util/helpers';

// Data
const state = {
	user_industries:[],
}

const getters = make.getters(state)

const mutations = make.mutations(state)

const actions = {
	...make.actions(state),
	getUserIndustries: ({ dispatch }) => {
		api.user_industry.index()
			.then(response => dispatch('setUser_industries', response.data))
			.catch(error => {
				console.log(error);
				toast.add(error.message, 'error')
			})
	},
}

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters,
}
